export default {
  data() {
    return {};
  },
  methods: {
    showSnackbar(message, color) {
      let snackbarInfo = {
        enable: true,
        color: color,
        timeout: 3000,
        text: message,
        top: true,
        bottom: false,
        left: false,
        right: true,
        vertical: false,
        multiline: false
      };
      this.$store.dispatch("changeSnackbarInfo", snackbarInfo);
    },
    showSnackbarDelay(u, k, t) {
      let snackbarInfo = {
        enable: true,
        color: k,
        timeout: t,
        text: u,
        top: true,
        bottom: false,
        left: false,
        right: true,
        vertical: false,
        multiline: false
      };
      this.$store.dispatch("changeSnackbarInfo", snackbarInfo);
    },
    generateIdleTimer(colour, text) {
      let snackbarInfo = {
        enable: true,
        color: colour,
        timeout: 120000,
        text: text,
        top: true,
        bottom: false,
        left: false,
        right: true,
        vertical: false,
        multiline: false
      };
      this.$store.dispatch("changeSnackbarInfo", snackbarInfo);
    },
    generateInfoSnackbar(colour, text) {
      let snackbarInfo = {
        enable: true,
        color: colour,
        timeout: 7000,
        text: text,
        top: true,
        bottom: false,
        left: false,
        right: true,
        vertical: false,
        multiline: false
      };
      this.$store.dispatch("changeSnackbarInfo", snackbarInfo);
    },
    generateInfoSnackbarIdANDTitle(colour, text, id, title) {
      let snackbarInfo = {
        enable: true,
        color: colour,
        timeout: 3000,
        text: text + " " + id + " " + title + ".",
        top: true,
        bottom: false,
        left: false,
        right: true,
        vertical: false,
        multiline: false
      };
      this.$store.dispatch("changeSnackbarInfo", snackbarInfo);
    },
    generateInfoSnackbarMessage(colour, text, message) {
      let snackbarInfo = {
        enable: true,
        color: colour,
        timeout: 3000,
        text: text + " " + message + ".",
        top: true,
        bottom: false,
        left: false,
        right: true,
        vertical: false,
        multiline: false
      };
      this.$store.dispatch("changeSnackbarInfo", snackbarInfo);
    }
  }
};
